export const TIME_FORMATS = {
    DATE: "DD/MM/YYYY",
    DATE_TIME: "DD/MM/YYYY - HH:mm",
    TIME: "HH:mm",
};
